/**
 * Клієнтська копія логіки `lib/materialStockUnitPriceUAH.js` (шлях для webpack у `client/`).
 */
import { getWindingMetersFromPropertyPairs } from "../helpers/materialWindingMeters";

/** Одиниці складу лічаться в метрах (`м` / `m`). */
export function materialUnitLooksLikeMeters(unit) {
    const u = String(unit ?? "")
        .trim()
        .toLowerCase();
    return u === "м" || u === "m";
}

/**
 * Ціна за одиницю складу (м, кг, шт…) для списання й оцінки техкарт та складу в ₴.
 * Якщо `unitPriceBasis === "bobbin"` і заповнена «Намотка» (м на бобіну) — поле `priceUAH`
 * на картці трактується як ціна за одну бобіну; для норм у метрах використовується ₴/м = priceUAH ÷ намотка.
 */
export function effectiveStockUnitPriceUAH(material) {
    const raw = Number(material?.priceUAH);
    if (!Number.isFinite(raw) || raw < 0) {
        return null;
    }
    const basis = material?.unitPriceBasis;
    const w = getWindingMetersFromPropertyPairs(material?.propertyPairs);
    if (
        basis === "bobbin" &&
        materialUnitLooksLikeMeters(material?.unit) &&
        w != null &&
        w > 0
    ) {
        return raw / w;
    }
    return raw;
}

/**
 * Те саме для `priceUSD`, якщо на картці в USD збережено ціну за бобіну.
 */
export function effectiveStockUnitPriceUSD(material) {
    const raw = Number(material?.priceUSD);
    if (!Number.isFinite(raw) || raw < 0) {
        return null;
    }
    const basis = material?.unitPriceBasis;
    const w = getWindingMetersFromPropertyPairs(material?.propertyPairs);
    if (
        basis === "bobbin" &&
        materialUnitLooksLikeMeters(material?.unit) &&
        w != null &&
        w > 0
    ) {
        return raw / w;
    }
    return raw;
}
